import React, { useState, useEffect } from 'react';

const clients = [
  {
    name: "RUSELL & CLARKE (E.A) LIMITED",
    logoType: "initials",
    initials: "R&C",
    color: "from-blue-500 to-indigo-600",
    description: "Excavation and Supporting of Approach and Discharge Tunnels at Thwake Dam - USD 2,827,888.91",
    industry: "infrastructure"
  },
  {
    name: "QWALI GROUP OF COMPANIES",
    logoType: "geometric",
    initials: "QGC",
    color: "from-emerald-500 to-green-600",
    description: "Transport of Shale and Lime - USD 120,277.24",
    industry: "transport"
  },
  {
    name: "CGGC (Main Contractor)",
    logoType: "modern",
    initials: "CGGC",
    color: "from-red-500 to-rose-600",
    description: "Supplement for Excavation Protection, Supporting and Drainage Works for Main Spillway - USD 1,200,000.00",
    industry: "construction"
  },
  {
    name: "CHINA CITY CONSTRUCTION COMPANY",
    logoType: "architectural",
    initials: "CCCC",
    color: "from-amber-500 to-orange-600",
    description: "Supply and Transport of Road Sub Base Material - USD 894,156.29",
    industry: "construction"
  },
  {
    name: "THE THIRD ENGINEERING BUREAU OF CHINA CITY CONS GROUP CO. LTD",
    logoType: "engineering",
    initials: "TEBCC",
    color: "from-purple-500 to-violet-600",
    description: "Supply and Transport of Road Sub Base Material - USD 1,017,536.67",
    industry: "engineering"
  },
  {
    name: "VICTORIA ENGINEERING COMPANY LIMITED",
    logoType: "corporate",
    initials: "VEC",
    color: "from-teal-500 to-cyan-600",
    description: "Transport of Boulders and Supply of Road Sub Base Material - USD 124,495.27",
    industry: "engineering"
  },
  {
    name: "CHINA JIANXI YOUSE INTERNATIONAL LTD",
    logoType: "international",
    initials: "CJYI",
    color: "from-indigo-500 to-blue-600",
    description: "Supply and Transport of Road Sub Base Material - USD 171,948.82",
    industry: "international"
  },
  {
    name: "KIPISH INVESTMENTS LIMITED",
    logoType: "investment",
    initials: "KIL",
    color: "from-green-500 to-emerald-600",
    description: "Supply and Transport of Feldspur-Kajiado - USD 70,303.00",
    industry: "investment"
  },
  {
    name: "CHINA ROAD AND BRIDGE CORPORATION",
    logoType: "international",
    initials: "CRBC",
    color: "from-slate-500 to-gray-600",
    description: "Road Infrastructure and Bridge Construction Projects - USD 3,200,000.00",
    industry: "infrastructure"
  }
];

// Dynamic Logo Component
const DynamicLogo = ({ client, size = "large" }) => {
  const sizeClasses = {
    small: "w-12 h-12 text-xs",
    medium: "w-16 h-16 text-sm",
    large: "w-24 h-24 lg:w-32 lg:h-32 text-lg lg:text-xl"
  };

  const renderLogoContent = () => {
    switch (client.logoType) {
      case "initials":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <span className="font-bold text-white z-10">{client.initials}</span>
            <div className="absolute inset-2 border-2 border-white/30 rounded-lg" />
          </div>
        );
      
      case "geometric":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute inset-3 bg-white/20 rotate-45 rounded-sm" />
            <div className="absolute inset-4 bg-white/30 rotate-12 rounded-sm" />
            <span className="font-bold text-white z-10 text-xs lg:text-sm">{client.initials}</span>
          </div>
        );
      
      case "modern":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute top-2 left-2 w-3 h-3 bg-white/40 rounded-full" />
            <div className="absolute top-2 right-2 w-2 h-2 bg-white/60 rounded-full" />
            <div className="absolute bottom-2 left-2 w-2 h-2 bg-white/60 rounded-full" />
            <div className="absolute bottom-2 right-2 w-3 h-3 bg-white/40 rounded-full" />
            <span className="font-bold text-white z-10 text-xs lg:text-sm">{client.initials}</span>
          </div>
        );
      
      case "architectural":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute inset-3">
              <div className="w-full h-1 bg-white/30 mb-1" />
              <div className="w-3/4 h-1 bg-white/40 mb-1" />
              <div className="w-1/2 h-1 bg-white/50 mb-1" />
              <div className="w-full h-1 bg-white/30" />
            </div>
            <span className="font-bold text-white z-10 text-xs">{client.initials}</span>
          </div>
        );
      
      case "engineering":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute inset-3 border-2 border-white/30 rounded-full" />
            <div className="absolute inset-5 border border-white/40" style={{clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)'}} />
            <span className="font-bold text-white z-10 text-xs">{client.initials}</span>
          </div>
        );
      
      case "corporate":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute inset-2 bg-white/20 rounded-lg" />
            <div className="absolute inset-3 border-l-2 border-t-2 border-white/40 rounded-tl-lg" />
            <span className="font-bold text-white z-10 text-xs lg:text-sm">{client.initials}</span>
          </div>
        );
      
      case "international":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute inset-3 rounded-full border-2 border-white/30" />
            <div className="absolute inset-4 rounded-full bg-white/20" />
            <span className="font-bold text-white z-10 text-xs">{client.initials}</span>
          </div>
        );
      
      case "investment":
        return (
          <div className="relative w-full h-full flex items-center justify-center">
            <div className="absolute inset-3">
              <div className="w-full h-full bg-white/20 transform rotate-45 rounded-sm" />
              <div className="absolute inset-1 bg-white/30 rounded-sm" />
            </div>
            <span className="font-bold text-white z-10 text-xs">{client.initials}</span>
          </div>
        );
      
      default:
        return <span className="font-bold text-white">{client.initials}</span>;
    }
  };

  return (
    <div className={`${sizeClasses[size]} bg-gradient-to-br ${client.color} rounded-2xl shadow-lg relative overflow-hidden group-hover:scale-105 transition-transform duration-300`}>
      <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      {renderLogoContent()}
    </div>
  );
};

// Industry Icon Component
const IndustryIcon = ({ industry, className = "w-4 h-4" }) => {
  const icons = {
    infrastructure: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
    transport: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
      </svg>
    ),
    construction: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    engineering: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    international: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    investment: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    )
  };

  return icons[industry] || icons.construction;
};

const Clients = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % clients.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const trustStats = [
    { number: "6.49M+", label: "Total Project Value (USD)" },
    { number: "12+", label: "Major Clients" },
    { number: "8+", label: "Completed Projects" },
    { number: "100%", label: "Client Satisfaction" }
  ];

  return (
    <section id="clients" className="relative min-h-screen bg-slate-950 overflow-hidden">
      {/* Enhanced Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Gradient overlays */}
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gradient-to-br from-emerald-500/20 to-teal-600/20 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-gradient-to-br from-blue-500/15 to-indigo-500/15 rounded-full blur-3xl animate-float-delayed" />
        
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(34,197,94,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(34,197,94,0.05)_1px,transparent_1px)] bg-[size:40px_40px] opacity-30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 lg:py-32">
        
        {/* Section Header */}
        <div className="text-center mb-20 animate-fade-in">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 backdrop-blur-sm border border-emerald-500/20 rounded-full px-4 py-2 text-sm font-medium text-emerald-400 mb-6">
            <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" />
            Trusted Partners
          </div>
          
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Our Valued
            <span className="block bg-gradient-to-r from-emerald-400 via-teal-500 to-cyan-600 bg-clip-text text-transparent">
              Clients
            </span>
          </h2>
          
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            We are proud to partner with leading organizations across Kenya, 
            delivering exceptional construction and engineering solutions that drive national development.
          </p>
        </div>

        {/* Featured Client Showcase */}
        <div className="mb-16 animate-slide-up">
          <div className="relative min-h-[400px] sm:min-h-[450px] lg:min-h-[500px] overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center p-4">
              <div className="group relative w-full max-w-4xl">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 to-teal-600/20 rounded-3xl blur opacity-0 group-hover:opacity-100 transition-all duration-500" />
                <div className="relative bg-slate-900/50 backdrop-blur-xl border border-slate-700/50 rounded-3xl p-6 sm:p-8 lg:p-12 hover:border-emerald-500/30 transition-all duration-500">
                  <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
                    <div className="flex-shrink-0">
                      <DynamicLogo client={clients[currentIndex]} size="large" />
                    </div>
                    <div className="flex-1 text-center lg:text-left">
                      <div className="flex items-center justify-center lg:justify-start gap-2 mb-2">
                        <IndustryIcon industry={clients[currentIndex].industry} className="w-5 h-5 text-emerald-400" />
                        <span className="text-emerald-400 text-sm font-medium capitalize">{clients[currentIndex].industry}</span>
                      </div>
                      <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-2 sm:mb-3 line-clamp-2">
                        {clients[currentIndex].name}
                      </h3>
                      <p className="text-slate-300 text-base sm:text-lg leading-relaxed mb-3 sm:mb-4 line-clamp-3 sm:line-clamp-none">
                        {clients[currentIndex].description}
                      </p>
                      <div className="flex items-center justify-center lg:justify-start gap-2 text-emerald-400 text-sm font-medium">
                        <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse" />
                        Ongoing Partnership
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Client Navigation Dots */}
        <div className="flex justify-center mb-20 animate-fade-in-delayed">
          <div className="flex items-center gap-3 bg-slate-900/30 backdrop-blur-sm border border-slate-700/50 rounded-full px-6 py-3">
            {clients.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex 
                    ? 'bg-emerald-400 shadow-lg shadow-emerald-400/50' 
                    : 'bg-slate-600 hover:bg-slate-500'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Client Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20 animate-slide-up-delayed">
          {clients.map((client, index) => (
            <div key={index} className="group relative">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/10 to-teal-500/10 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-all duration-500" />
              <div className="relative bg-slate-900/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 hover:border-emerald-500/30 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <DynamicLogo client={client} size="small" />
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <IndustryIcon industry={client.industry} className="w-3 h-3 text-emerald-400" />
                      <span className="text-emerald-400 text-xs capitalize">{client.industry}</span>
                    </div>
                    <h4 className="text-white font-semibold text-sm leading-tight">{client.name}</h4>
                  </div>
                </div>
                <p className="text-slate-400 text-xs leading-relaxed">{client.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Stats */}
        <div className="bg-slate-900/30 backdrop-blur-sm border border-slate-700/50 rounded-3xl p-8 lg:p-12 animate-fade-in-delayed">
          <div className="text-center mb-8">
            <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4">Building Trust Through Excellence</h3>
            <p className="text-slate-300 max-w-2xl mx-auto leading-relaxed">
              Our commitment to quality and reliability has earned us the trust of Kenya's most 
              prestigious organizations and government institutions.
            </p>
          </div>
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {trustStats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-emerald-400 to-teal-500 bg-clip-text text-transparent mb-1">
                  {stat.number}
                </div>
                <div className="text-sm text-slate-400 uppercase tracking-wider">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a href="#contact">
            <button className="group relative px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-semibold rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-emerald-500/25 hover:-translate-y-1">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-teal-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <span className="relative flex items-center gap-2">
                Partner With Us
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </button>
            </a>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-30px) rotate(-5deg); }
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 10s ease-in-out infinite 2s;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
        .animate-fade-in-delayed {
          animation: fade-in 0.8s ease-out 0.4s both;
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out 0.2s both;
        }
        .animate-slide-up-delayed {
          animation: slide-up 0.8s ease-out 0.4s both;
        }
      `}</style>
    </section>
  );
};

export default Clients;